var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMcgovernLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 215,
    height: 50,
    viewBox: "0 0 215 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "y30xa",
    d: "M88.25 55.725H69.37V36.843H88.25zM78.058 78.449H59.177V69.76h10.192V59.568h8.689zM65.526 59.569v6.349h-6.35v-6.349zm-18.882 6.349V47.036h18.882v8.689H55.333v10.192zM92.094 33H65.526v10.192H42.8V69.76h12.532v12.533h26.568V59.568h10.193z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y30xb",
    d: "M110.266 76.68h-.997v-9.798h.997z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y30xc",
    d: "M125.35 75.227h.029v-8.345h.996v9.799h-1.246l-5.702-8.429h-.027v8.429h-.996v-9.799h1.245z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y30xd",
    d: "M139.26 68.46a2.396 2.396 0 0 0-.816-.713c-.333-.18-.734-.27-1.205-.27-.24 0-.484.037-.733.111-.25.074-.476.187-.678.339a1.747 1.747 0 0 0-.492.575c-.124.23-.186.502-.186.816 0 .314.06.572.179.775.12.203.278.376.476.52.198.142.424.26.676.352.254.092.518.184.794.277.34.11.683.23 1.028.36.345.129.656.297.932.505.276.207.501.47.676.789.175.318.262.721.262 1.21 0 .49-.093.912-.28 1.267a2.653 2.653 0 0 1-.726.879 3.02 3.02 0 0 1-1.022.511 4.126 4.126 0 0 1-1.155.167c-.295 0-.59-.03-.886-.09a4.045 4.045 0 0 1-.844-.27 3.443 3.443 0 0 1-1.356-1.093l.858-.637c.212.35.51.643.892.879.383.235.833.353 1.35.353.249 0 .503-.039.761-.118.258-.078.491-.198.699-.36.208-.161.378-.36.512-.594.134-.236.2-.51.2-.824 0-.341-.066-.625-.2-.851a1.794 1.794 0 0 0-.532-.568 3.289 3.289 0 0 0-.762-.38 34.427 34.427 0 0 0-.9-.304 11.633 11.633 0 0 1-.954-.347 3.208 3.208 0 0 1-.845-.505 2.343 2.343 0 0 1-.601-.768c-.153-.304-.23-.678-.23-1.121 0-.471.096-.876.285-1.218.189-.341.435-.623.74-.844a3.099 3.099 0 0 1 1.01-.484 4.118 4.118 0 0 1 1.093-.153c.665 0 1.232.118 1.703.353.47.236.825.514 1.066.837z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y30xe",
    d: "M150.747 76.68h-.996v-8.912h-3.28v-.886h7.556v.886h-3.28z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y30xf",
    d: "M162.026 76.68h-.997v-9.798h.997z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y30xg",
    d: "M173.305 76.68h-.996v-8.912h-3.28v-.886h7.557v.886h-3.28z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y30xh",
    d: "M187.2 76.93c-.738 0-1.342-.127-1.813-.38a3.232 3.232 0 0 1-1.12-.963 3.533 3.533 0 0 1-.575-1.266 5.719 5.719 0 0 1-.16-1.294v-6.145h.997v6.035c0 .396.046.782.138 1.155.093.374.243.706.45.996.208.29.483.526.824.706.341.18.761.27 1.26.27.498 0 .917-.09 1.259-.27.34-.18.616-.415.823-.706.208-.29.358-.622.45-.996a4.8 4.8 0 0 0 .138-1.155v-6.035h.997v6.145c0 .406-.053.838-.16 1.294a3.52 3.52 0 0 1-.573 1.266 3.216 3.216 0 0 1-1.129.963c-.475.253-1.077.38-1.805.38z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y30xi",
    d: "M202.092 76.68h-.996v-8.912h-3.28v-.886h7.556v.886h-3.28z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y30xj",
    d: "M213.37 75.795h5.246v.886h-6.242v-9.799h6.076v.886h-5.08v3.363h4.748v.886h-4.747z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y30xk",
    d: "M124.164 56.997l.095-11.892h-.07l-4.369 11.892h-2.848l-4.249-11.892h-.07l.093 11.892h-3.82V40.191h5.774l3.827 10.777h.095l3.66-10.777h5.87v16.806z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y30xl",
    d: "M141.781 45.033a2.657 2.657 0 0 0-1.012-.772 3.105 3.105 0 0 0-1.306-.294c-.463 0-.88.093-1.254.28a3.016 3.016 0 0 0-.96.747c-.266.31-.475.67-.626 1.08-.151.408-.227.843-.227 1.306 0 .461.072.897.214 1.305.142.41.351.769.626 1.08.276.31.604.555.987.732.381.18.812.269 1.293.269a3.6 3.6 0 0 0 1.318-.255 2.524 2.524 0 0 0 1.054-.733l2.425 2.96c-.55.533-1.262.95-2.132 1.252a8.387 8.387 0 0 1-2.772.453 8.794 8.794 0 0 1-2.936-.48 6.821 6.821 0 0 1-2.37-1.399 6.584 6.584 0 0 1-1.582-2.226c-.384-.87-.577-1.856-.577-2.958 0-1.085.193-2.062.577-2.933a6.597 6.597 0 0 1 1.582-2.227 7.014 7.014 0 0 1 2.37-1.412 8.493 8.493 0 0 1 2.91-.493c.48 0 .954.044 1.425.133.47.089.924.21 1.36.36.435.152.835.338 1.2.56.363.223.68.467.945.734z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y30xm",
    d: "M160.305 57.02c-1.1.27-2.3.405-3.596.405-1.345 0-2.583-.215-3.715-.642-1.132-.427-2.104-1.028-2.92-1.805a8.22 8.22 0 0 1-1.91-2.787c-.46-1.085-.689-2.291-.689-3.621 0-1.344.234-2.562.7-3.655a8.115 8.115 0 0 1 1.935-2.79 8.564 8.564 0 0 1 2.896-1.768c1.108-.41 2.302-.617 3.584-.617 1.33 0 2.563.202 3.704.606 1.139.403 2.064.946 2.776 1.626l-2.563 2.92c-.396-.46-.918-.836-1.567-1.128-.649-.293-1.385-.439-2.207-.439-.713 0-1.37.13-1.97.391a4.72 4.72 0 0 0-1.568 1.093 4.943 4.943 0 0 0-1.032 1.661 5.813 5.813 0 0 0-.367 2.1c0 .776.11 1.488.332 2.137.221.648.55 1.206.984 1.673.436.466.974.831 1.615 1.093.64.26 1.373.39 2.196.39.474 0 .925-.035 1.352-.107.428-.07.823-.186 1.187-.343v-3.062h-3.204v-3.276h6.931v8.902c-.823.426-1.784.774-2.884 1.043z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y30xn",
    d: "M181.04 48.523a5.77 5.77 0 0 0-.357-2.042 4.873 4.873 0 0 0-.985-1.625 4.55 4.55 0 0 0-1.52-1.07 4.827 4.827 0 0 0-1.957-.39c-.712 0-1.361.131-1.947.39a4.723 4.723 0 0 0-1.518 1.07c-.428.45-.757.993-.986 1.625a5.943 5.943 0 0 0-.344 2.042c0 .76.119 1.46.355 2.1.238.641.566 1.19.986 1.651.419.459.922.818 1.507 1.08.586.26 1.235.391 1.947.391s1.36-.131 1.946-.391a4.653 4.653 0 0 0 1.52-1.08c.427-.46.759-1.01.996-1.65.238-.641.356-1.341.356-2.101zm4.343 0c0 1.329-.23 2.544-.688 3.643a8.298 8.298 0 0 1-1.91 2.825 8.514 8.514 0 0 1-2.909 1.816c-1.124.426-2.342.64-3.655.64-1.314 0-2.528-.214-3.644-.64a8.54 8.54 0 0 1-2.896-1.816 8.288 8.288 0 0 1-1.91-2.825c-.46-1.1-.689-2.314-.689-3.643 0-1.346.23-2.559.689-3.644a7.988 7.988 0 0 1 1.91-2.765 8.534 8.534 0 0 1 2.896-1.757c1.116-.41 2.33-.617 3.644-.617 1.313 0 2.531.207 3.655.617 1.124.412 2.093.998 2.908 1.757a7.998 7.998 0 0 1 1.91 2.765c.46 1.085.689 2.298.689 3.644z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y30xo",
    d: "M197.317 56.997h-4.059l-6.361-16.806h4.557l3.893 11.917h.095l3.868-11.917h4.487z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y30xp",
    d: "M207.073 56.997V40.191h11.667v3.42h-7.751v3.179h6.978v3.252h-6.978v3.489h7.704v3.466z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y30xq",
    d: "M230.435 47.848h-3.122v-4.214h3.122c1.308 0 2.323.8 2.323 2.082 0 1.345-1.015 2.132-2.323 2.132zm2.73 2.73c1.815-.432 3.706-2.044 3.706-5.002 0-3.122-2.17-5.42-5.674-5.42h-7.883v16.845h3.999v-5.992h1.827l3.301 5.992h4.532z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y30xr",
    d: "M251.824 56.997l-6.766-10.99h-.07l.095 10.99h-3.94V40.191h4.628l6.741 10.967h.071l-.095-10.967h3.94v16.806z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-42 -33)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    xlinkHref: "#y30xa"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    xlinkHref: "#y30xb"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    xlinkHref: "#y30xc"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    xlinkHref: "#y30xd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    xlinkHref: "#y30xe"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    xlinkHref: "#y30xf"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    xlinkHref: "#y30xg"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    xlinkHref: "#y30xh"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    xlinkHref: "#y30xi"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    xlinkHref: "#y30xj"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    xlinkHref: "#y30xk"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    xlinkHref: "#y30xl"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    xlinkHref: "#y30xm"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    xlinkHref: "#y30xn"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    xlinkHref: "#y30xo"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    xlinkHref: "#y30xp"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    xlinkHref: "#y30xq"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    xlinkHref: "#y30xr"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMcgovernLogo);
export default __webpack_public_path__ + "static/media/mcgovern_logo.f9a3c40799f8fc362162c6075d225650.svg";
export { ForwardRef as ReactComponent };